function enableDragScroll(target) {
  if (!target) return;

  let animationId = 0;
  let isDragging = false;
  let velocity = 0;
  let lastTime = 0;
  let startX = 0;

  target.addEventListener('mousedown', startDrag)

  function startDrag(e) {
    // 保存X坐标值
    startX = e.clientX;

    lastTime = performance.now();
    cancelAnimationFrame(animationId);

    document.addEventListener('mousemove', drag);

    // 注：这里之所以监听click事件而非mouseup，是因为在mouseup事件中无法阻止click默认行为，如果拖拽行为发生在链接标签上，拖拽结束后会错误触发链接跳转。
    document.addEventListener('click', stopDrag, {
      passive: false,
      capture: true,
    });
  };

  function drag(e) {
    const movedX = Math.abs(e.clientX - startX);

    // 只有当移动距离超过阈值时才认为是拖拽
    if (movedX > 5) {
      isDragging = true;

      const now = performance.now();
      const deltaTime = now - lastTime;

      if (deltaTime > 0) {
        const deltaX = e.movementX;
        target.scrollLeft -= deltaX;
        velocity = (-deltaX / deltaTime) * 1000; // pixels per second
        lastTime = now;
      }
    }
  }

  function stopDrag(e) {
    if (isDragging) {
      isDragging = false;
      e.stopPropagation();
      e.preventDefault();

      // 惯性滚动效果
      if (Math.abs(velocity) > 10) {
        // Only apply inertia if velocity is significant
        applyInertia();
      }
    }

    document.removeEventListener('mousemove', drag);
    document.removeEventListener('click', stopDrag, true);
  }

  function applyInertia() {
    const friction = 0.95;
    const minVelocity = 0.5;

    const animate = () => {
      if (Math.abs(velocity) < minVelocity) {
        velocity = 0;
        return;
      }

      velocity *= friction;
      target.scrollLeft += velocity / 60; // Divide by 60 to get movement per frame

      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);
  }

  return function destroyDragScroll() {
    cancelAnimationFrame(animationId);
    document.removeEventListener('mousemove', drag);
    document.removeEventListener('click', stopDrag, true);
    target.removeEventListener('mousedown', startDrag);
  };
}
